import type { ReactNode } from "react";

import { HaNErrorBoundary } from "../../shared/HaNErrorBoundary";
import { useHaNLayoutMode } from "../../state/layout/useHaNLayoutMode";

// Over the bottom of the map in the phone map view, with the floor selector above it. Wider screens list the results
// in the sidebar instead, so there it doesn't exist.
export const HaNCarousel = ({ children }: { children: ReactNode }) => {
  const layoutMode = useHaNLayoutMode();

  if (layoutMode !== "mobile") return null;

  return (
    <div className="relative z-10 col-start-1 row-start-5 flex justify-center self-end overflow-hidden pb-5 empty:hidden group-data-[mobile-view=list]/han:hidden">
      <HaNErrorBoundary area="Carousel">{children}</HaNErrorBoundary>
    </div>
  );
};
